<template>
    <modal
        ref="subjectivitiesModal"
        :title="`Subjectivities`"
        :actionText="canEdit ? `Save and Close` : `Close`"
        cancelText="Close"
        :confirmation="canEdit"
    >
        <template v-if="loading">
            <loading-spinner/>
        </template>

        <template v-else>
            <x-form ref="form" @submit.prevent="updateSubjectivities">
                <x-data-table
                    class="no-row-hover dashed-rows"
                    :headers="headers"
                    :items="subjectivities"
                    :sort-desc="[false]"
                    hide-actions
                >
                    <template v-slot:items="subjectivity">
                        <td>
                            <check-icon
                                class="pointer"
                                v-model="subjectivity.item.selected"
                                @click="toggleSelect(subjectivity.item.name)"
                                :disabled="!canEdit"
                            />
                        </td>

                        <td style="text-align: left">
                            <p
                                v-if="!subjectivity.item.draft"
                            >
                                {{ subjectivity.item.name }}
                            </p>

                            <x-textarea
                                v-else
                                v-model="subjectivity.item.name"
                                auto-grow
                                :rules="[(v) => ruleRequired(v, 'Subjectivity')]"
                                rows="1"
                            />
                        </td>
                    </template>
                </x-data-table>

                <x-btn
                    v-if="canEdit"
                    outline
                    small
                    @click="addDraftSubjectivity"
                >
                    <x-icon>add</x-icon> Add subjectivity
                </x-btn>
            </x-form>
        </template>
    </modal>
</template>

<script>
    import Modal from '~/components/Shared/UIComponents/Modal';
    import CheckIcon from '~/components/Shared/UIComponents/CheckIcon';
    import rules from '~/mixins/rules';

    export default {
        mixins: [rules],
        components: {
            Modal,
            CheckIcon
        },
        props: {
            offer: {
                type: Object,
            },
            readonly: {
                type: Boolean,
            }
        },
        data() {
            return {
                subjectivities: [],
                headers: [
                    {
                        text: '',
                        align: 'left',
                        sortable: false,
                        value: 'selected',
                        width: '10%'
                    },
                    {
                        text: '',
                        align: 'left',
                        sortable: false,
                        value: 'name'
                    }
                ],
                subjectivityTypes: [
                    'Satisfactory review of underlying documentation',
                    'Capacity being available at the time of binding',
                    'No material adverse change',
                    'Details of prior experience',
                ],
                loading: false
            }
        },
        created() {
            this.computeSubjectivities();
        },
        watch: {
            "offer.subjectivities"() {
                this.computeSubjectivities();
            }
        },
        computed: {
            canEdit() {
                return (this.$root.userIsPlacingBrokerUser() || this.$root.userIsProducingBrokerUser()) && !this.readonly;
            }
        },
        methods: {
            async open() {
                if (await this.$refs.subjectivitiesModal.open()) {
                    this.updateSubjectivities();
                }
            },
            computeSubjectivities() {
                this.subjectivities = this.subjectivityTypes.map(subjectivity => {
                    return {
                        name: subjectivity,
                        selected: Boolean(this.offer.subjectivities.find(offerSubjectivity => offerSubjectivity.name === subjectivity)),
                        draft: false
                    };
                });

                const customSubjectivities = this.offer.subjectivities
                    .filter(subjectivity    =>  !this.subjectivityTypes.includes(subjectivity.name))
                    .map(subjectivity   =>  {
                        return {
                            name: subjectivity.name,
                            selected: true,
                            draft: false
                        }
                    });

                this.subjectivities.push(...customSubjectivities);
            },
            toggleSelect(subjectivityName) {
                this.subjectivities.find(subjectivity => subjectivity.name == subjectivityName).selected = !this.subjectivities.find(subjectivity => subjectivity.name == subjectivityName).selected;
            },
            addDraftSubjectivity() {
                this.subjectivities.push({
                    name: '',
                    selected: true,
                    draft: true
                });
            },
            async updateSubjectivities() {
                if (!this.canEdit) {
                    return;
                }
                const requestData = {
                    subjectivities: this.subjectivities
                        .filter(subjectivity => subjectivity.selected)
                        .map(subjectivity => (subjectivity.name))
                };
                if (this.$refs.form.validate()) {
                    this.open();
                    this.loading = true;
                    const response = await axios.put(this.$root.api(`broker/submission/${this.offer.submission_id}/offer/${this.offer.id}/sync-subjectivities`), requestData);
                    this.$emit('subjectivitiesUpdated', response.data.data);
                    this.loading = false;
                    this.$refs.subjectivitiesModal.resolveAndClose(false);
                } else {
                    this.open();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.pointer {
    cursor: pointer;
}
</style>
